import React, { useEffect, useState } from 'react'
import { IoIosAddCircleOutline } from 'react-icons/io'
import AddTimeSheetPopup from './AddTimeSheetPopup'
import ViewTimeSheetPopup from './ViewTimeSheetPopup'
import axios from 'axios'
import { FallingLines } from 'react-loader-spinner'
import { LuPanelLeftOpen } from "react-icons/lu";
import { LuPanelRightOpen } from "react-icons/lu";
import user1 from "../../images/ic_no_person_photo.svg";
import Button from '@mui/joy/Button';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { toast } from 'react-toastify';
import { format } from "date-fns";
import { base_url } from '../../utils/AxiosConfig'
import * as XLSX from 'xlsx';
import { base_url_image_view_api } from '../../utils/ImageViewingAPI'
import SnackbarNotification from '../../utils/SnackbarNotification'





const Wps = () => {

  const [countOfSuccessGeneration, setCountOfSuccessGeneration] = useState(0)

  const startOfMonth = new Date();
  startOfMonth.setUTCDate(1);

  let initialStartingDate = format(startOfMonth, 'yyyy-MM-dd')
  let initialEndingDate = format(new Date(), 'yyyy-MM-dd')

  const [timeSheetData, setTimeSheetData] = useState({
    startDate: initialStartingDate,
    endDate: initialEndingDate
  })
  const [branchListFromAPI,setBranchListFromAPI]=useState([])
  const [branch,setBranch]=useState('-')
  const [deptListFromAPI,setDeptListFromAPI]=useState([])
  const [dept,setDept]=useState('-')
  const [gradeListFromAPI,setGradeListFromAPI]=useState([])
  const [grade,setGrade]=useState('-')
  const [isLoading, setIsLoading] = useState(false);

  // Handle input change
  const handleChangeDate = (e) => {
    const { name, value } = e.target;
    setTimeSheetData({
      ...timeSheetData,
      [name]: value,
    });
  };


  const handleChange = (event, eventType) => {
    switch (eventType) {
      case "division": setDivisionMUI(event.target.value);
    }

  };


 const getBranchList = async () => {
          const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }
      const response = await axios.get(
        `${base_url}/api/MASTERLIST/${companyCode}/DEPARTMENT/-`
        // `${base_url}/api/MASTERLIST/CUBIX/DEPARTMENT/-`
      );
      if (response?.data) {
        let newArray = response.data.filter(
          (itemFilly) => itemFilly.Description != ""
        );
  
        setBranchListFromAPI(newArray.map((i)=>i.Description))
      } else {
        console.log("error");
      }
    };

  const getDeptList = async () => {
      const response = await axios.get(
        `${base_url}/api/MASTERLIST/${companyCode}/DEPT/-`
        // `${base_url}/api/MASTERLIST/CUBIX/DEPT/-`
      );
      if (response?.data) {
        let newArray = response.data.filter(
          (itemFilly) => itemFilly.Description != ""
        );
  
        console.log('dept newArray',newArray)
        setDeptListFromAPI(newArray.map((i)=>i.Description));

      } else {
        console.log("error");
      }
    };

    const getGradeList = async (companyCode) => {
      
      const response = await axios.get(
        // `${base_url}/api/MASTERLIST/CUBIX/GRADE/-`
        `${base_url}/api/MASTERLIST/${companyCode}/GRADE/-`
      );
      if (response?.data) {
        let newArray = response.data.filter(
          (itemFilly) => itemFilly.Description != ""
        );
  
        // console.log('newArrayList',newArray.map((i)=>i.Description))
        // console.log('newArray',newArray)
        setGradeListFromAPI(newArray.map((i)=>i.Description));
        // setGrade(newArray);
      } else {
        console.log("error");
      }
    };

  const [selectedDivision, setSelectedDivision] = useState(null);
  const [selectedDivisionCode, setSelectedDivisionCode] = useState("-")

  const [divisionMUI, setDivisionMUI] = React.useState('');
  const storedUserDataArray = JSON.parse(localStorage.getItem("BondTimeuserDataArray"));
  const storedLoginUser = JSON.parse(localStorage.getItem("BondTimeLoginUserData")) || [];
  let user = null
  let companyCode = null


  if (storedLoginUser) {
    user = storedLoginUser[0].salesman_name.trim()
  }

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode
  }

  const [allBranchData, setAllBranchData] = useState([])
  const [openViewModal, setOpenViewModal] = React.useState(false);

  const [data, setData] = useState();
  const [reset, setReset] = useState(false);
  const [loader, setLoader] = useState(true);
  const [popUpData, setpopUpData] = useState(null);
  const [Open, setOpen] = useState(false);
  const [companyCodeFromAPI, setCompanyCodeFromAPI] = useState(null);

  // pagination
  const [currentPage, SetcurrentPage] = useState(1);
  const recordsPerPage = 10;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = data?.slice(firstIndex, lastIndex);
  const npage = Math.ceil(data?.length / recordsPerPage);
  const numbers = Array.from({ length: npage }, (_, i) => i + 1);



  const fetchProfilePic = (ImagePath) => {
    const filePath = ImagePath.replace(/\\/g, "/");
    const fileName = filePath.split('/').pop(); // Extracts the last part (filename with extension)

    // Construct the full URL for the image
    return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
  };

  useEffect(() => {
    const getData = async () => {
      try {

        const storedUserDataArray = JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
        let companyCode = null

        if (storedUserDataArray) {
          companyCode = storedUserDataArray[0].cmpcode
          setCompanyCodeFromAPI(storedUserDataArray[0].cmpcode)
        }

        const response = await axios.get(
          `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/ALL/ALL/ALL/ALL`
        );
        if (response?.data) {
          setData(response.data);

          setReset(false);
        }

      } catch (error) {
        console.error('PersonalInfoListerror:', error);
      }
    };

    // getData();
        // fetchPayrollData(companyCode);
    getBranchList(companyCode);
    getDeptList(companyCode);
    getGradeList(companyCode);
  }, []);


  const getWPSData = () => {

    setLoader(true);
        const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

    // let apiWPSUrl = `${base_url}/api/WPSGen/CUBIX/-/-/${timeSheetData.startDate}/${timeSheetData.endDate}`
    //  `${base_url}/api/Payroll/CUBIX/${payslipStartDate}/${payslipEndDate}/${branch}/${dept}/${grade}`

    // let apiWPSUrl = `${base_url}/api/WPSGen/CUBIX/${timeSheetData.startDate}/${timeSheetData.endDate}/${branch}/${dept}/${grade}`
    let apiWPSUrl = `${base_url}/api/WPSGen/${companyCode}/${timeSheetData.startDate}/${timeSheetData.endDate}/${branch}/${dept}/${grade}`

    console.log("apiUrl timesheet ", apiWPSUrl)

    axios.get(apiWPSUrl).then((res) => {

      // setIsCallingAPI(false)
      console.log("res -->", res.data)

      setData(res.data)
      setLoader(false);
          // showSnackbar('success', 'WPS Data Fetched Succesfully');


    }).catch((err) => {
      console.log('getWPSDataErr', err)
      // toast.error('Some Error Occured')
      showSnackbar('error', 'Some Error Occured');
      setLoader(false);

      // setIsCallingAPI(false)
    })
  }

  const downloadExcel = () => {
    // Convert the API data to a worksheet
    const ws = XLSX.utils.json_to_sheet(data);

    // Create a new workbook and append the worksheet to it
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Data");

    // Export the workbook to Excel and trigger a download
    XLSX.writeFile(wb, "data.xlsx");
  };

  useEffect(() => {
    // Call getWPSData only if all dependencies are available
    if (base_url && timeSheetData?.startDate && timeSheetData?.endDate) {
      getWPSData();
    }
  }, [base_url]);

  useEffect(() => {
    if (data) {
      setLoader(false);
    }
  }, [data]);

  const fetchAllBranchData = async () => {
    try {
      const response = await axios.get(`${base_url}/api/MasterCount/${companyCode}/BRANCH/${user}/-`)

      if (response.status === 200) {
        setAllBranchData(response.data)
      }
    } catch (error) {
      console.log('fetchAllBranchDataErr', error)
    }
  }

  useEffect(() => {
    fetchAllBranchData()
  }, [])

  const callGenerateTimeSheetAPI = async () => {

    for (let i = 0; i < records?.length; i++) {

      setIsLoading(true);

      try {
        const payload = [
          {
            mode: "ENTRY",
            cmpcode: companyCode,
            Empid: records[i]?.EmpId,
            StartDate: timeSheetData.startDate,
            EndDate: timeSheetData.endDate,
            deptno: selectedDivisionCode,
            jobcode: "-",
          },
        ];

        console.log("payload ", payload)

        const response = await axios.post(
          `${base_url}/api/TimesheetReg`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {

          setCountOfSuccessGeneration(prev => prev + 1)

          setTimeSheetData({
            startDate: "",
            endDate: ""
          })
        } else {
          //toast.error("Failed to submit timesheet.");
        }
      } catch (error) {
        //toast.error("An error occurred while submitting timesheet.");
      } finally {
        setIsLoading(false);
      }

    }

  };


    const [snackbar, setSnackbar] = useState({
      open: false,
      severity: 'success',
      message: '',
    });
  
  
    const showSnackbar = (severity, message) => {
      setSnackbar({ open: true, severity, message });
    };
  
    const handleClose = () => {
      setSnackbar({ ...snackbar, open: false });
    };

  return (
    <div className="container">
      <div className='flex  justify-between items-center '>
      <div className="row">
        <div className="col-6 d-flex align-items-center justify-content-between">
            <div>
              <h6 className=" text-2xl font-bold text-gray-600 flex  justify-start items-center">
                {/* <MdPeopleOutline className="mr-2" /> */}

                <span>WPS</span>
              </h6>
            </div>
        </div>

        {/* <div className="col-6">
          <div className="text-end">
            {Open === true ? <>< LuPanelRightOpen onClick={() => setOpen(false)} /></> : null}
            {Open === false ? <><LuPanelLeftOpen onClick={() => setOpen(true)} /></> : null}
          </div>
        </div> */}

      </div>

      <div className='flex items-end justify-center mb-4'>
 {/* <div className="flex justify-center items-end gap-4 "> */}
          {/* Branch Select */}
 <FormControl variant="standard" sx={{ m: 1, minWidth: 180 }} size="small">
  <InputLabel id="branch-select-label">Branch</InputLabel>
  <Select
    labelId="branch-select-label"
    value={branch}
    // onChange={(e) => handleChange(e, "division")}
    label="Branch"
  >
    <MenuItem value="">
      <em>None</em>
    </MenuItem>
    {branchListFromAPI?.map((b) => (
      <MenuItem
        key={b.DEPTNO}
        value={b}
        onClick={() => {
        //   setSelectedDivision(b.deptnodesc);
          setBranch(b);
        }}
      >
        {b}
      </MenuItem>
    ))}
  </Select>
</FormControl>

<FormControl variant="standard" sx={{ m: 1, minWidth: 180 }} size="small">
  <InputLabel id="department-select-label">Department</InputLabel>
  <Select
    labelId="department-select-label"
    value={dept}
    // onChange={(e) => handleChange(e, "department")}
    label="Department"
  >
    <MenuItem value="">
      <em>None</em>
    </MenuItem>
    {deptListFromAPI?.map((dept) => (
      <MenuItem
        // key={dept.id}
        value={dept}
        onClick={() => {
          setDept(dept);
        //   setSelectedDepartmentCode(dept.code);
        }}
      >
        {dept}
      </MenuItem>
    ))}
  </Select>
</FormControl>

 <FormControl variant="standard" sx={{ m: 1, minWidth: 180 , fontSize:'8px' }} size="small">
  <InputLabel id="grade-select-label">Grade</InputLabel>
  <Select
    labelId="grade-select-label"
    value={grade}
    // onChange={(e) => handleChange(e, "grade")}
    label="Grade"
  >
    <MenuItem value="">
      <em>None</em>
    </MenuItem>
    {gradeListFromAPI?.map((g) => (
      <MenuItem
        // key={g.TranId}
        value={g}
        onClick={() => {
          setGrade(g);
        }}
      >
        {g}
      </MenuItem>
    ))}
  </Select>
</FormControl>  
      

        <div className='d-flex  '>
          <div className='ml-4'>
            <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Start Date</label>
            <input type="date"
              class="form-control"
              id="startDate"
              name="startDate"
              value={timeSheetData.startDate}
              onChange={handleChangeDate}
                max={new Date().toISOString().split('T')[0]} 
            />

          </div>

          <div class="ms-2">
            <label for="exampleInputEmail1" class="form-label fs-small text-secondary">End Date</label>
            <input
              type="date"
              class="form-control"
              id="endDate"
              name="endDate"
              value={timeSheetData.endDate}
              onChange={handleChangeDate}
                max={new Date().toISOString().split('T')[0]} 
            />

          </div>
        </div>

        <button
          onClick={() => getWPSData()}
          className='btn btn-sm  mx-4'
          style={{ backgroundColor: "#bc5090", color: "#ffffff" }}
        >
          View
        </button>


        <div style={{
          marginLeft: 'auto'
        }}>
          {/* <button className='dash-btn' style={{ */}
          <button className='bg-blue-500 px-1 py-1 rounded text-white text-sm' style={{
            width: '140px'
          }}
            onClick={downloadExcel}
          >
            Download Excel
          </button>
        </div>
      </div>
 </div>
      {/* <div className='m-2'>Number Of Successful Generation
        <span className='ms-2' style={{ fontWeight: "bold" }}>{countOfSuccessGeneration}</span>
      </div> */}



      {/* <div className={Open ? "table scroll" : "table scroll"}> */}
      <div>
        {
          records ? <>
          {/* <table class="table"> */}
          <table className="shadow-sm min-w-full bg-white rounded-sm border border-gray-300 text-xs ">
            <thead >
              <tr className="bg-gray-200">
                <th className="px-2 py-1 border font-normal">Column A</th>
                <th className="px-2 py-1 border font-normal">Column B</th>
                <th className="px-2 py-1 border font-normal">Column C</th>
                <th className="px-2 py-1 border font-normal">Column D</th>
                <th className="px-2 py-1 border font-normal">Column E</th>
                <th className="px-2 py-1 border font-normal">Column F</th>
                <th className="px-2 py-1 border font-normal">Column G</th>
                <th className="px-2 py-1 border font-normal">Column H</th>
                <th className="px-2 py-1 border font-normal">Column I</th>
                <th className="px-2 py-1 border font-normal">Column J</th>
                {/* {Open ? <>
                  <td>Bank Account</td>
                  <td>Bank Name</td>
                  <td>Agent Id</td>
                  <td>Current Address</td>
                  <td>Home Address</td>
                  <td>Home Airport</td>
                  <td>Work Mobile</td>
                  <td>Work Phone</td>
                  <td>Personal Phone</td>
                  <td>Personal Email</td>
                  <td>Passport Number</td>
                  <td>Passport Issue Date</td>
                  <td>Passport Expiry Date</td>
                  <td>Passport Place of Issue</td>
                  <td>Passport Country of Issue</td>
                  <td>Emirates id</td>
                  <td>Expiry Date</td>
                  <td>Visa No</td>
                  <td>Visa Expiry Date</td>
                  <td>Insurance Number</td>
                  <td>Insurance Expiry Date</td>
                  <td>Driving license No</td>
                  <td>Driving license Expiry Date</td>
                  <td>Basic Pay</td>
                  <td>Allowances_OT</td>
                  <td>Allownaces_NOT</td>
                  <td>NormalHRS</td>
                  <td>HourlyWage</td>
                  <td>OTRate</td>
                  <td>SplOtRate</td>
                  <td>Active</td>
                  <td>Memos</td>
                  <td>Notes</td>
                  <td>Salary Ac</td>
                  <td>Advance Ac</td>

                </> : null} */}
                {/* <td>Action</td> */}

              </tr>
              </thead>
              <tbody>
              {records
                ? records?.map((d, i) => (<>
                  {/* <tr key={i} className="dataTr"> */}
                  <tr key={i} className="">
                    <td className="px-2 py-1 border">{d['Column A']}</td>
                    <td className="px-2 py-1 border">{d['Column B']}</td>
                    <td className="px-2 py-1 border">{d['Column C']}</td>
                    <td className="px-2 py-1 border">{d['Column D']}</td>
                    <td className="px-2 py-1 border">{d['Column E']}</td>
                    <td className="px-2 py-1 border">{d['Column F']}</td>
                    <td className="px-2 py-1 border">{d['Column G']}</td>
                    <td className="px-2 py-1 border">{d['COLUMN H']}</td>
                    <td className="px-2 py-1 border">{d['COLUMN I']}</td>
                    <td className="px-2 py-1 border">{d['COLUMN J']}</td>
                    {/* <td>{d?.EmpId}</td>
                    <td>{d?.AlternateID}</td>
                    <td>{d?.Status}</td> */}
                    {/* <td>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {
                          d.imagepath ?

                            <img style={{
                              width: "25px",
                              height: "25px",
                              borderRadius: "50%",
                              objectFit: "cover",
                              marginRight: "4px"
                            }} src={fetchProfilePic(d.imagepath)} alt="" /> :
                            <img style={{
                              width: "25px",
                              height: "25px",
                              borderRadius: "50%",
                              objectFit: "cover",
                              marginRight: "4px"
                            }} src={user1} alt="" />
                        }
                        <span>{d?.Name}</span>
                      </div>
                    </td> */}
                    {/* <td>{d?.JobTitle}</td>
                    <td>{d?.Division}</td>
                    <td>{d?.Grade}</td>
                    <td>{d?.Single}</td>
                    <td>{d?.Nationality}</td>
                    {Open ? <>
                      <td>{d?.BankAccountNo}</td>
                      <td>{d?.BankName}</td>
                      <td>{d?.AgentID}</td>
                      <td>{d?.CurrentAddress}</td>
                      <td>{d?.HomeAddress}</td>
                      <td>{d?.HomeAirport}</td>
                      <td>{d?.WorkMobile}</td>
                      <td>{d?.WorkPhone}</td>
                      <td>{d?.PersonalPhone}</td>
                      <td>{d?.PersonalEmail}</td>
                      <td>{d?.PassportNo}</td>
                      <td>{d?.PassportIssueDate}</td>
                      <td>{d?.PassportExpiryDate}</td>
                      <td>{d?.PassportPlaceofIssue}</td>
                      <td>{d?.PassportCountryofIssue}</td>
                      <td>{d?.EmiratesId}</td>
                      <td>{d?.EmiratesIdExpiryDate}</td>
                      <td>{d?.VisaNo}</td>
                      <td>{d?.VisaExpiryDate}</td>
                      <td>{d?.InsuranceNo}</td>
                      <td>{d?.InsuranceExpiryDate}</td>
                      <td>{d?.DrivingLicenceNo}</td>
                      <td>{d?.DrivingLicenceExpiryDate}</td>
                      <td>{d?.BasicPay}</td>
                      <td>{d?.Allowances_OT}</td>
                      <td>{d?.Allowances_NOT}</td>
                      <td>{d?.NormalHrs}</td>
                      <td>{d?.HourlyWage}</td>
                      <td>{d?.OTrate}</td>
                      <td>{d?.SplOtRate}</td>
                      <td>{d?.Active}</td>
                      <td>{d?.Memos}</td>
                      <td>{d?.Notes}</td>
                      <td>{d?.SalaryA}</td>
                      <td>{d?.AdvanceAc}</td>

                    </> : null} */}
                    {/* <td>
                      <button
                        className="dash-btn"
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop"
                        onClick={() => setpopUpData(d)}
                      >
                        <IoIosAddCircleOutline />
                        &nbsp;Generate
                      </button>
                      &nbsp;
                      <button
                        className="dash-btn mt-1"
                        onClick={() => { setpopUpData(d); setOpenViewModal(true) }}
                      >
                        <IoIosAddCircleOutline />
                        &nbsp;View
                      </button>
                    </td> */}
                  </tr>
                </>)) : null}

            </tbody>
          </table></> : null
        }
      </div>
      {
        records ? (<>
          <div className="pagination-div mt-4">
            <div className="text-end">
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li class="page-item">
                    {
                      currentPage !== 1 ? (
                        <button class="page-link" href="#" onClick={prePage}>
                          Previous
                        </button>
                      ) : ''
                    }
                  </li>
                  {numbers.map((n, i) => (
                    <li
                      className={`page-item  ${currentPage === n ? "active" : ""
                        }`}
                      key={i}
                    >
                      <button
                        // className="page-link bg-red-100"
                        className="page-link rounded"
                        onClick={() => changeCPage(n)}
                        href="#"
                      >
                        {n}
                      </button>
                    </li>
                  ))}

                  <li class="page-item">
                    {
                      currentPage !== numbers[numbers.length - 1] ? (
                        <button class="page-link" href="#" onClick={nextPage}>
                          Next
                        </button>
                      ) : null
                    }
                  </li>
                </ul>
              </nav>
            </div>
                    <SnackbarNotification
        open={snackbar.open}
        severity={snackbar.severity}
        message={snackbar.message}
        onClose={handleClose}

      />
          </div>
        </>) : null
      }
      <AddTimeSheetPopup popUpData={popUpData} />
      {
        popUpData &&

        <ViewTimeSheetPopup popUpData={popUpData} setOpenViewModal={setOpenViewModal} openViewModal={openViewModal} setpopUpData={setpopUpData} />

      }

      <div className="table-nodata-img mtd">
        {loader ? (
          <>
            {" "}
            <div className="table-nodata-img">
              <div className="center">
                <p className="text-center pt-5">
                  Please Wait Loading Data... &nbsp;
                  <FallingLines />
                </p>
              </div>
            </div>
          </>
        ) : null}
      </div>
    </div>
  )
  function prePage() {
    if (currentPage !== firstIndex) {
      SetcurrentPage(currentPage - 1);
    }
  }
  function changeCPage(id) {
    SetcurrentPage(id);
  }

  function nextPage() {
    if (currentPage !== lastIndex) {
      SetcurrentPage(currentPage + 1);
    }
  }
}


export default Wps